import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    overflow: 'hidden',
    '& .MuiTabs-scroller': {
      overflowY: 'auto !important',
    },
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: '250px',
    height: '500px',
    '& .MuiTabs-flexContainerVertical': {
      overflow: 'hidden',
      paddingBottom: '5px',
    },
    '&:focus': {
      outline: '1px solid black',
    },
    '& > *:last-child': {
      marginBottom: '10px',
      marginTop: '-10px'
    },
    minWidth: '170px',
  },
  indicator: {
    display: 'none',
  },
  tab: {
    textTransform: 'none',
  },
}));
